import metadataLanguageJson from '@/assets/metadataLanguages.json';
import { IOptions } from '@/data/models/option';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetMetadataLanguagesQuery(): UseQueryResult<
  IOptions[],
  Error
> {
  return useQuery({
    queryKey: ['metadataLanguages'],
    queryFn: async () => {
      return metadataLanguageJson.map((ml) => ({
        label: ml.DisplayName,
        value: ml.Reference,
      }));
    },
    staleTime: Infinity,
  });
}
